var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenieSoloIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_89_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0H10C5.58172 0 2 3.58172 2 8V25C2 29.4183 5.58172 33 10 33H28C32.4183 33 36 29.4183 36 25V8C36 3.58172 32.4183 0 28 0Z",
    fill: "#21A7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0.5H10C5.85786 0.5 2.5 3.85786 2.5 8V25C2.5 29.1421 5.85786 32.5 10 32.5H28C32.1421 32.5 35.5 29.1421 35.5 25V8C35.5 3.85786 32.1421 0.5 28 0.5Z",
    stroke: "url(#paint0_linear_89_215)",
    strokeOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9233 17.5062C22.6683 18.0094 21.3135 18.3198 19.8965 18.4002C19.6522 18.4141 19.4059 18.4211 19.1581 18.4211C18.9102 18.4211 18.664 18.4141 18.4196 18.4002C17.0023 18.3197 15.6473 18.0092 14.3919 17.5058C11.7576 16.4493 9.56238 14.5432 8.15308 12.1305C10.3498 8.37003 14.4556 5.84003 19.1581 5.84003C23.8606 5.84003 27.9664 8.37003 30.1631 12.1305C28.7536 14.5434 26.5581 16.4497 23.9233 17.5062Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3917 18.4851C14.0883 18.3634 13.7906 18.2304 13.4993 18.0867C12.5526 18.7471 11.7523 19.5696 11.1497 20.508C12.174 22.1031 13.7694 23.3633 15.6841 24.0618C16.5964 24.3946 17.5813 24.5999 18.6114 24.6531H19.6848C20.7147 24.5999 22.5248 25.6103 19.8963 28.1599C21.8113 27.4615 26.1221 22.1033 27.1465 20.508C26.5456 19.5723 25.7482 18.7518 24.805 18.0923C24.5171 18.234 24.2229 18.3653 23.9231 18.4855C22.6681 18.9887 21.3133 19.2991 19.8963 19.3795C19.652 19.3934 19.4058 19.4004 19.1579 19.4004C18.91 19.4004 18.6638 19.3934 18.4194 19.3795C17.0021 19.299 15.6471 18.9885 14.3917 18.4851Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6069 10.5213H15.7322C14.6934 10.5213 13.8513 11.3634 13.8513 12.4022C13.8513 13.441 14.6934 14.2831 15.7322 14.2831H22.6069C23.6457 14.2831 24.4878 13.441 24.4878 12.4022C24.4878 11.3634 23.6457 10.5213 22.6069 10.5213Z",
    fill: "#162550"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1027 13.0711C22.4873 13.0711 22.7991 12.7623 22.7991 12.3814C22.7991 12.0005 22.4873 11.6918 22.1027 11.6918C21.7181 11.6918 21.4062 12.0005 21.4062 12.3814C21.4062 12.7623 21.7181 13.0711 22.1027 13.0711Z",
    fill: "#04FED1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1481 22.3501C19.5327 22.3501 19.8445 22.0413 19.8445 21.6604C19.8445 21.2795 19.5327 20.9708 19.1481 20.9708C18.7635 20.9708 18.4517 21.2795 18.4517 21.6604C18.4517 22.0413 18.7635 22.3501 19.1481 22.3501Z",
    fill: "#162550"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3627 13.0711C16.7473 13.0711 17.0591 12.7623 17.0591 12.3814C17.0591 12.0005 16.7473 11.6918 16.3627 11.6918C15.9781 11.6918 15.6663 12.0005 15.6663 12.3814C15.6663 12.7623 15.9781 13.0711 16.3627 13.0711Z",
    fill: "#04FED1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3627 22.3501C16.7473 22.3501 17.0591 22.0413 17.0591 21.6604C17.0591 21.2795 16.7473 20.9708 16.3627 20.9708C15.9781 20.9708 15.6663 21.2795 15.6663 21.6604C15.6663 22.0413 15.9781 22.3501 16.3627 22.3501Z",
    fill: "#162550"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9342 22.3501C22.3189 22.3501 22.6307 22.0413 22.6307 21.6604C22.6307 21.2795 22.3189 20.9708 21.9342 20.9708C21.5496 20.9708 21.2378 21.2795 21.2378 21.6604C21.2378 22.0413 21.5496 22.3501 21.9342 22.3501Z",
    fill: "#162550"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_89_215",
    x: 0,
    y: 0,
    width: 42,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.654902 0 0 0 0 0.87451 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_89_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_89_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_215",
    x1: 2,
    y1: 16.5,
    x2: 36,
    y2: 16.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C94AB",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878072,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C94AB",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieSoloIcon);
export default __webpack_public_path__ + "static/media/genieSoloIcon.3851ab8840403a2ba05f695e234fb656.svg";
export { ForwardRef as ReactComponent };